import { type ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useMe } from './MeContext';
import type { ConsoleSection } from '../lib/api/operatorConsole';

/**
 * Route guard for a console section. Typing a URL directly must not open a
 * page a team member cannot use — the API would answer 403 and the page
 * would render as a broken error state instead of an honest "no access".
 *
 * Cosmetic only: the backend gate (BaseController#authorize_console_section!)
 * is what actually protects the data.
 */
export function RequireSection({
  section,
  children,
}: {
  section: ConsoleSection;
  children: ReactNode;
}) {
  const { can } = useMe();

  // Dashboard is open to everyone, so it is always a safe place to land.
  if (!can(section)) return <Navigate to="/" replace />;

  return <>{children}</>;
}
